"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.recoverAiAnalysisOutputDtoSchema = exports.recoverAiAnalysisInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const ops_action_target_dto_js_1 = require("./ops-action-target.dto.js");
exports.recoverAiAnalysisInputDtoSchema = ops_action_target_dto_js_1.opsActionTargetSchema.extend({
    analysisRunId: z.string().min(1),
    mode: z.nativeEnum(cadstrom_shared_1.AiAnalysisRecoveryMode),
    startFresh: z.boolean(),
    reason: z.string().trim().min(1).max(2000).optional(),
});
exports.recoverAiAnalysisOutputDtoSchema = z.object({
    workflowId: z.string(),
    alreadyRunning: z.boolean(),
    uiUrl: z.string().nullable(),
});
//# sourceMappingURL=ai-analysis-recovery.dto.js.map